import { render, staticRenderFns } from "./SelectDocument.vue?vue&type=template&id=f0d94d78&"
import script from "./SelectDocument.vue?vue&type=script&lang=js&"
export * from "./SelectDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports